export default {"src":"/_next/static/media/QuoteIcon.10a23a5e.svg","height":33,"width":43,"blurWidth":0,"blurHeight":0};